import { render, staticRenderFns } from "./OverviewCard.vue?vue&type=template&id=2052093e&scoped=true&"
import script from "./OverviewCard.vue?vue&type=script&lang=js&"
export * from "./OverviewCard.vue?vue&type=script&lang=js&"
import style0 from "./OverviewCard.vue?vue&type=style&index=0&id=2052093e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2052093e",
  null
  
)

export default component.exports